/**
 * Produzido (plano 4.6): o que a fábrica de fato terminou em cada período
 * passado, contra o que o ritmo DA ÉPOCA esperava. Medido, sem semáforo.
 */
import { contarDiasUteis, menorIso } from "./calendario";
import { calcularRitmo, intervaloProvisorio } from "./ritmo";

function contarTerminos(terminos, de, ate) {
  return (terminos || []).filter((t) => t?.termino && t.termino >= de && t.termino <= ate).length;
}

/**
 * `produzidoDoPeriodo({periodo, terminos, naoUteis, hoje, anosComRegistro?})`
 *
 * - Período inteiramente passado: `{realizado, esperado, pct, ritmoDaEpoca,
 *   motivo, provisorio, corrente:false}`; `esperado` = ritmo com a janela
 *   relativa ao início do período × du do período (`null` + `motivo` quando
 *   o ritmo daquela época não pode ser calculado).
 * - Período corrente: só `realizado` até hoje.
 * - `provisorio`: o período toca as semanas 0, −1 ou −2, cujos términos
 *   ainda chegam atrasados.
 * - Período futuro: `null`.
 */
export function produzidoDoPeriodo({ periodo, terminos, naoUteis, hoje, anosComRegistro } = {}) {
  if (periodo.inicio > hoje) return null;
  const provisorio = periodo.fim >= intervaloProvisorio(hoje).de;
  const realizado = contarTerminos(terminos, periodo.inicio, menorIso(periodo.fim, hoje));
  if (periodo.fim >= hoje) {
    return { corrente: true, realizado, esperado: null, pct: null, ritmoDaEpoca: null, motivo: null, provisorio };
  }
  const daEpoca = calcularRitmo({ terminos, naoUteis, hoje: periodo.inicio, anosComRegistro, horizonteAte: periodo.fim });
  const esperado = daEpoca.ritmo ? daEpoca.ritmo * contarDiasUteis(periodo.inicio, periodo.fim, naoUteis) : null;
  return {
    corrente: false,
    realizado,
    esperado,
    pct: esperado ? Math.round((100 * realizado) / esperado) : null,
    ritmoDaEpoca: daEpoca.ritmo,
    motivo: daEpoca.motivo,
    provisorio,
  };
}
